import type { CollectionTileData } from './types'
import type {
  ViewItemListEvent,
  ZodSelectItemEvent,
} from '@moonpig/web-core-analytics'

export const createViewListEvent = (
  tiles: CollectionTileData[],
  label: string,
  itemBrand: string,
): ViewItemListEvent => ({
  event: 'view_item_list',
  ecommerce: {
    items: tiles.map((tile, index) => ({
      index: index + 1,
      item_brand: itemBrand,
      item_list_name: label,
      item_name: tile.title.toLowerCase(),
      quantity: 1,
      item_id: tile.title.toLowerCase().replace(/[^a-z0-9-]/g, ''),
      price: 0,
    })),
    value: 0,
    currency: 'GBP',
    mission: tiles[0].mission,
  },
  event_data: {
    action: 'view item list',
    category: 'product action',
    label: label,
    non_interaction: true,
  },
})

export const createSelectItemEvent = ({
  label,
  action,
  category,
  tile,
  itemBrand,
  index,
  mission,
}: {
  label: string
  action: string
  category: string
  tile: CollectionTileData
  itemBrand: string
  index: number
  mission: string
}): ZodSelectItemEvent => ({
  event: 'select_item',
  ecommerce: {
    items: [
      {
        index: index + 1,
        item_brand: itemBrand,
        item_list_name: label,
        item_name: tile.title.toLowerCase(),
        quantity: 1,
        item_id: tile.title.toLowerCase().replace(/[^a-z0-9-]/g, ''),
        price: 0,
      },
    ],
    value: 0,
    currency: 'GBP',
    mission,
  },
  event_data: {
    action,
    category,
    label,
    non_interaction: true,
  },
})
